import { createAction, props } from "@ngrx/store"
import { ProductCategoryDto, settlementAccountDto, WalletDto } from "./products.dtos"
import { Bank,  MerchantProduct, MerchantSettlementBankAccount, MerchantWallet, ProductCategory, ValidatedAccount } from "./products.interfaces"

export const fetchMerchantProducts = createAction(
    '[Products Module] fetch merchant products'
)

export const fetchMerchantProductsFailed = createAction(
    '[Products Module] STATUS: fetch merchant products failed'
)

export const fetchMerchantProductsSuccess = createAction(
    '[Products Module] STATUS: fetch merchant products success',
    props<{merchantProducts: MerchantProduct[]}>()
)

export const createProductCategory = createAction(
    '[Products Module] create product category',
    props<{productCategoryDto: ProductCategoryDto}>()
)

export const createProductCategoryFailed = createAction(
    '[Products Module] STATUS: create product category failed'
)

export const createProductCategorySuccess = createAction(
    '[Products Module] STATUS: create product category success'
)


export const fetchProductCategories = createAction(
    '[Products Module] fetch product categories'
)

export const fetchProductCategoriesFailed = createAction(
    '[Products Module] STATUS: fetch product categories failed'
)

export const fetchProductCategoriesSuccess = createAction(
    '[Products Module] STATUS: fetch product categories success',
    props<{productCategories: ProductCategory[]}>()
)

export const fetchBanks = createAction(
    '[Products Module] fetch banks'
)

export const fetchBanksFailed = createAction(
    '[Products Module] STATUS: fetch banks failed'
)

export const fetchBanksSuccess = createAction(
    '[Products Module] STATUS: fetch banks success',
    props<{banks: Bank[]}>()
)


export const fetchWallets = createAction(
    '[Products Module] fetch wallets'
)

export const fetchWalletsFailed = createAction(
    '[Products Module] STATUS: fetch wallets failed'
)

export const fetchWalletsSuccess = createAction(
    '[Products Module] STATUS: fetch wallets success',
    props<{wallets: MerchantWallet[]}>()
)



export const fetchSettlementAccount = createAction(
    '[Products Module] fetch settlement accounts'
)

export const fetchSettlementAccountFailed = createAction(
    '[Products Module] STATUS: fetch settlement accounts failed'
)

export const fetchSettlementAccountSuccess = createAction(
    '[Products Module] STATUS: fetch settlement accounts success',
    props<{settlementAccounts: MerchantSettlementBankAccount[]}>()
)


export const createWallet = createAction(
    '[Products Module] create wallet',
    props<{walletDto}>()
)

export const createWalletFailed = createAction(
    '[Products Module] STATUS: create wallet failed'
)

export const createWalletSuccess = createAction(
    '[Products Module] STATUS: create wallet success'
)

export const createWalletUK1 = createAction(
    '[Products Module] create wallet uk 1',
    props<{walletDto}>()
)

export const createWalletUK1Failed = createAction(
    '[Products Module] STATUS: create wallet uk 1 failed'
)

export const createWalletUK1Success = createAction(
    '[Products Module] STATUS: create wallet uk 1 success'
)

export const createWalletUK2 = createAction(
    '[Products Module] create wallet uk 2',
    props<{walletDto}>()
)

export const createWalletUK2Failed = createAction(
    '[Products Module] STATUS: create wallet uk 2 failed'
)

export const createWalletUK2Success = createAction(
    '[Products Module] STATUS: create wallet uk 2 success'
)

export const createProduct = createAction(
    '[Products Module] create product',
    props<{productDto}>()
)

export const createProductFailed = createAction(
    '[Products Module] STATUS: create product failed'
)

export const createProductSuccess = createAction(
    '[Products Module] STATUS: create product success'
)


export const editProduct = createAction(
    '[Products Module] edit product',
    props<{productDto}>()
)

export const editProductFailed = createAction(
    '[Products Module] STATUS: edit product failed'
)

export const editProductSuccess = createAction(
    '[Products Module] STATUS: edit product success'
)


export const createSettlementAccount = createAction(
    '[Products Module] create settlement account',
    props<{settlementAccountDto: settlementAccountDto}>()
)

export const createSettlementAccountFailed = createAction(
    '[Products Module] STATUS: create settlement account failed'
)

export const createSettlementAccountSuccess = createAction(
    '[Products Module] STATUS: create settlement account success'
)



export const validateAccount = createAction(
    '[Products Module]  validate account',
    props<{ bankCode: string, accountNumber: string, countryCode: string}>()
)

export const validateAccountFailed = createAction(
    '[Products Module] STATUS:  validate account failed'
)

export const validateAccountSuccess = createAction(
    '[Products Module] STATUS:  validate account success',
    props<{accountDetails: ValidatedAccount}>()
)